import React, { useState } from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"

import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent
} from "../../components/common/UiPageElements"
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import Footer from "../../components/footer/Footer"
import LoyaltyHomeBanner from "./Views/LoyaltyHomeBanner"
import HowLoyaltyWorks from "./Views/HowLoyaltyWorks"
import { TermsAndConditions } from './Views/TermsAndConditions'
import LoyaltySignUp from "./Views/LoyaltySignUp"
import Stores from "./Views/StoresWithCanEarnPoints"
import { useNavigate } from "react-router-dom";

export default function LoyaltyHome(props) {
    let navigate = useNavigate(); 
    const signUp = () =>{ 
        let path = `../../ui/loyalty-home-signed-up`; 
        navigate(path, { replace: true });
    }

    return (
        <>
     
            <UiMainWrapper>
                <TopHeader />
                <LoyaltyHomeBanner/>
               
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentCol>
                                <HowLoyaltyWorks />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="7" xl="7">
                             <TermsAndConditions/>
                        </UiCol>
                        <UiCol lg="5" xl="5">
                            <UiContentCol>
                                <LoyaltySignUp  onClick={signUp}/>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentColWithSlider>
                                <UiColTitleWr >
                                    <UiColTitle
                                        title="Stores where you can earn loyalty points"
                                        subtitle="10,442 Carefully Selected Stores" />
                                    <UiViewAll className="sb-view-all-margin" />
                                </UiColTitleWr>

                                <Stores />
                            </UiContentColWithSlider>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
               
                <Footer />

            </UiMainWrapper>
        </>
    )
}



